import React from 'react';
import { History } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const ActivityLog = ({ post }) => {
  const events = [
    { color: 'bg-emerald-500', label: 'Post created', date: post.created_at, show: true },
    { color: 'bg-amber-500', label: 'Submitted for approval', date: post.updated_at, show: post.status !== 'draft' },
    { color: 'bg-blue-500', label: 'Approved', date: post.updated_at, show: ['approved', 'scheduled', 'published'].includes(post.status) },
    { color: 'bg-green-500', label: post.auto_published ? 'Auto-published' : 'Published', date: post.published_at, show: post.status === 'published' && !!post.published_at },
  ];

  return (
    <Card className="border-slate-100">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <History className="h-5 w-5" />
          Recent Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 text-sm">
          {events.filter(e => e.show).map((event) => (
            <div key={event.label} className="flex items-start gap-2">
              <div className={`w-2 h-2 rounded-full ${event.color} mt-1.5`} />
              <div>
                <p className="text-slate-700">{event.label}</p>
                <p className="text-xs text-slate-400">
                  {format(parseISO(event.date), 'MMM d, h:mm a')}
                </p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityLog;
